import { render, staticRenderFns } from "./CampaignDisplay.vue?vue&type=template&id=1c2c8055&"
import script from "./CampaignDisplay.vue?vue&type=script&lang=js&"
export * from "./CampaignDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports